import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InvoiceDisplayComponent } from './invoice-display.component';

const routes: Routes = [
  {
    path: '',
    component: InvoiceDisplayComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceDisplayRoutingModule {
}
